import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image";
import React from "react";

const Image = ({
  data,
  imageData = null,
  useImgTag = false,
  className,
  imgClassName,
  fetchpriority = "low",
  loading,
  ...props
}) => {
  if (!data) {
    return null;
  }
  const {
    altText,
    height,
    width,
    title,
    localFile: { extension, publicURL, childImageSharp },
  } = data;
  // `imageData` permette di forzare una variante specifica (es. ritaglio ad
  // aspect ratio) al posto della gatsbyImageData nativa.
  const gatsbyImageData = imageData || getImage(childImageSharp) || null;
  const alt = altText || title;

  if ((extension === "svg" && !gatsbyImageData) || useImgTag) {
    const src = getSrc(childImageSharp) || publicURL;

    if (!src) {
      return null;
    }

    return (
      <>
        <img
          src={src}
          alt={alt}
          height={height || "auto"}
          width={width || "auto"}
          fetchpriority={fetchpriority}
          loading={loading}
          className={className}
          {...props}
        />
      </>
    );
  }

  if (!gatsbyImageData) {
    return null;
  }

  return (
    <>
      <GatsbyImage
        image={gatsbyImageData}
        alt={alt}
        className={className}
        imgClassName={imgClassName}
        fetchpriority={fetchpriority}
        {...props}
      />
    </>
  );
};

export default Image;
